'use client';

import React, { useState } from 'react';
import styles from './ServiceAppointment.module.scss';
import Steps from './Steps/ServiceAndMaintenanceSteps';
import StepItem from './StepItem/ServiceAndMaintenanceStepItem';

const ServiceAppointment = ({ serviceAppointmentData }) => {
  // 处理Sitecore的步骤数据
  const processStepsData = (stepsData) => {
    if (!stepsData || !Array.isArray(stepsData)) {
      return [];
    }

    return stepsData.map((step, index) => ({
      id: index + 1,
      stepName: step.fields?.stepName?.value || `Step ${index + 1}`,
      activeStep: step.fields?.activeStep?.value || index === 0,
      category: step.fields?.category?.value || 'default',
      title: step.fields?.title?.value || `Step ${index + 1}`,
      text: step.fields?.text?.value || '',
      buttonText: step.fields?.buttonText?.value || 'Continue',
      buttonPath: step.fields?.buttonUrl?.value?.href || '',
      image: step.fields?.image,
    }));
  };

  const [steps, setSteps] = useState(processStepsData(serviceAppointmentData?.steps));

  const handleClickStep = (stepId) => {
    setSteps((prev) =>
      prev.map((item) => {
        return {
          ...item,
          activeStep: item.id === stepId,
        };
      })
    );
  };

  const activeStep = steps.find((step) => step.activeStep);
  const title = serviceAppointmentData?.title || 'How to schedule a service appointment';

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title} data-aos="fade-up">
        {title}
      </h2>
      <div className={styles.steps} data-aos="fade-up">
        <Steps steps={steps} onClickStep={handleClickStep} />
      </div>
      <div className={styles.main}>
        {activeStep && (
          <StepItem
            key={activeStep.id}
            step={activeStep}
            index={steps.indexOf(activeStep)}
            onClickStep={handleClickStep}
          />
        )}
      </div>
    </div>
  );
};

export default ServiceAppointment;
